import { CustomerMasterSourceType } from 'generated/bffFinancialInfo/models';
import { PaymentGatewayPaymentRequest } from 'generated/bffPaymentGateway/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';

export const api = {
  cpGetOnlinePaymentMethods: (url: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/online-payments/methods`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        paymentReason: 'financialDocument',
      },
    }),

  postPaymentGatewayPayment: (
    url: string,
    onlinePaymentRequest: PaymentGatewayPaymentRequest
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/payment-gateway/payment`,
      {
        caRefNo: onlinePaymentRequest.caRefNo,
        cuRefNo: onlinePaymentRequest.cuRefNo,
        documentId: onlinePaymentRequest.documentId,
        installmentId: onlinePaymentRequest.installmentId,
        paymentMethodId: Number(onlinePaymentRequest.paymentMethodId),
        installmentDueDate: onlinePaymentRequest.installmentDueDate,
        errorUrl: onlinePaymentRequest.errorUrl,
        failUrl: onlinePaymentRequest.failUrl,
        successUrl: onlinePaymentRequest.successUrl,
      },
      {
        params: {
          customerMasterSource: CustomerMasterSourceType.O2POP,
          channel: ChannelType.MO2_CARE,
        },
      }
    ),
};
